/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../bpa_client_src/app/components/wrapper/wrapper.component';
const styles_WrapperComponent:any[] = ([] as any[]);
export const RenderType_WrapperComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_WrapperComponent,data:{}});
export function View_WrapperComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),7,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1,
      278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),
      ['\n	'])),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),3,'section',[['class',
      'animate-fade-up page'],['id','content']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n		'])),i0.ɵncd((null as any),
      0),(_l()(),i0.ɵted(-1,(null as any),['\n	'])),(_l()(),i0.ɵted(-1,(null as any),
      ['\n']))],(_ck,_v) => {
    var _co:i2.WrapperComponent = _v.component;
    const currVal_0:any = _co.wrapperCssClass;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_WrapperComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-wrapper',
      ([] as any[]),(null as any),(null as any),(null as any),View_WrapperComponent_0,
      RenderType_WrapperComponent)),i0.ɵdid(1,114688,(null as any),0,i2.WrapperComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const WrapperComponentNgFactory:i0.ComponentFactory<i2.WrapperComponent> = i0.ɵccf('app-wrapper',
    i2.WrapperComponent,View_WrapperComponent_Host_0,{wrapperCssClass:'wrapperCssClass'},
    {},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9icGFfY2xpZW50X3NyYy9hcHAvY29tcG9uZW50cy93cmFwcGVyL3dyYXBwZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9icGFfY2xpZW50X3NyYy9hcHAvY29tcG9uZW50cy93cmFwcGVyL3dyYXBwZXIuY29tcG9uZW50LnRzIiwibmc6Ly8vdXNyL3NyYy9hcHAvc3JjL2JwYV9jbGllbnRfc3JjL2FwcC9jb21wb25lbnRzL3dyYXBwZXIvd3JhcHBlci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9icGFfY2xpZW50X3NyYy9hcHAvY29tcG9uZW50cy93cmFwcGVyL3dyYXBwZXIuY29tcG9uZW50LnRzLldyYXBwZXJDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IFtuZ0NsYXNzXT1cIndyYXBwZXJDc3NDbGFzc1wiPlxuXHQ8c2VjdGlvbiBpZD1cImNvbnRlbnRcIiBjbGFzcz1cImFuaW1hdGUtZmFkZS11cCBwYWdlXCI+XG5cdFx0PG5nLWNvbnRlbnQ+PC9uZy1jb250ZW50PlxuXHQ8L3NlY3Rpb24+XG48L2Rpdj4iLCI8YXBwLXdyYXBwZXI+PC9hcHAtd3JhcHBlcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQSwrRUFBQTtNQUFBO3FCQUFBLHlDQUFpQztNQUFBLFVBQ2hDO01BQUE7TUFBQSw4QkFBbUQsbURBQ2xEO01BQUEsR0FBeUIsMkNBQ2hCO01BQUE7O0lBSE47SUFBTCxXQUFLLFNBQUw7Ozs7b0JDQUE7TUFBQTtpQ0FBQSxVQUFBO01BQUE7SUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/bpa_client_src/app/components/wrapper/wrapper.component.ngfactory.ts